import axios from "axios";
import React, { useEffect, useState } from "react";

const VisaInstruction  = () => {
    const [visaInstructions, setVisaInstructions] = useState([]);
    const backendBaseUrl = process.env.REACT_APP_BACKEND_BASE_URL;

    const CACHE_KEY = 'visaInstructionsCache';
    const CACHE_TIME_KEY = 'visaInstructionsCacheTime';
    const CACHE_DURATION = 30 * 60 * 1000; // ৩০ মিনিট মিলিসেকেন্ডে

    useEffect(() =>{
        const cachedData = localStorage.getItem(CACHE_KEY);
        const cacheTime = localStorage.getItem(CACHE_TIME_KEY);
        const now = new Date().getTime();

        if (cachedData && cacheTime && now - cacheTime < CACHE_DURATION) {
            setVisaInstructions(JSON.parse(cachedData));
        } else {
            const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
            const Url = process.env.REACT_APP_API_VISA_INSTRUCTION;
            axios.get(`${apiBaseUrl}${Url}`)
                .then(response => {
                    setVisaInstructions(response.data);
                    localStorage.setItem(CACHE_KEY, JSON.stringify(response.data));
                    localStorage.setItem(CACHE_TIME_KEY, now.toString());
                })
                .catch(error => console.error("Error fetching API",error));
        }
    },[]);

    return (
        <div className="row g-4 py-2 wow fadeInUp" data-wow-delay=".25s">
            {visaInstructions.map((visaInstruction, index) => {
                return (
                    <div className="col-md-6" key={index}>
                        <div className="country-item counter-box" style={{backgroundColor: `${visaInstruction?.color}`}}>
                            <div className="icon">
                                <span className="">{visaInstruction?.serial}</span>
                            </div>
                            <div className="country-content">
                                <h4>{visaInstruction?.title}</h4>
                                <p>{visaInstruction?.details}</p>
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default VisaInstruction;
